// File: MallAboutSection.jsx
// Pure CSS + dummy images

import { Lightbulb, MapPinHouse, PenBox, PersonStanding, Rocket, Trophy } from 'lucide-react';
import React from 'react';

export default function AboutUsCard6() {
  return (<>
    <section className="mall-about">
      <div className="mall-grid">
        <div className="mall-left">
        <div className="cp-right-two">  <div className="feature-ac-6s">
         <div className="cp-years">
          <div className="big-ac-6">25</div>
          <div className="label-ac-6-two">Years Experience</div>
        </div>
            <div className="feature-ac-6">
              <div className="ficon-ac-6"><Lightbulb size={20} color={`#fff`} /></div>
              <div>
                <strong>Professional Service</strong>
                <p className="small-ac-6">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>

            <div className="feature-ac-6">
              <div className="ficon-ac-6"><MapPinHouse size={20} color={`#fff`} /></div>
              <div>
                <strong>100% Service Guarantee</strong>
                <p className="small-ac-6">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>
          </div></div>
           <div className="cr-record-grid-ac-6">
          <div className="rec-item-ac-6">
            <div className="ricon-ac-6"><PersonStanding size={40} color={`rgba(144, 202, 249,1)`} /></div>
            <div className="num-ac-6">786</div>
            <div className="label-ac-6">HAPPY CLIENTS</div>
          </div>

          <div className="rec-item-ac-6">
            <div className="ricon-ac-6"><Trophy size={40} color={`rgba(144, 202, 249,1)`} /></div>
            <div className="num-ac-6">69</div>
            <div className="label-ac-6">AWARDS</div>
          </div>

          <div className="rec-item-ac-6">
            <div className="ricon-ac-6"><Rocket size={40} color={`rgba(144, 202, 249,1)`} />
            </div>
            <div className="num-ac-6">1250</div>
            <div className="label-ac-6">PROJECT DONE</div>
          </div>

          <div className="rec-item-ac-6">
            <div className="ricon-ac-6"><PenBox size={40} color={`rgba(144, 202, 249,1)`} /></div>
            <div className="num-ac-6">12</div>
            <div className="label-ac-6">YEARS EXPERIENCE</div>
          </div>
        </div>
        </div>

        <div className="mall-right">
          <h2>About Us</h2>
          <div className="line"></div>
          <p>
            Welcome to GrandVista Mall, the ultimate shopping, dining, and entertainment destination.
            Designed to offer a world-class experience, our mall brings together a diverse collection
            of top brands and exciting attractions. We promise an unforgettable experience.
          </p>

          <div className="mall-mini-grid">
            <div className="mini-card">
              <img src="https://picsum.photos/300/350?random=41" alt="mission" />
              <button className="mini-btn">Mission ↗</button>
            </div>
            <div className="mini-card">
              <img src="https://picsum.photos/300/350?random=42" alt="vision" />
              <button className="mini-btn">Vision ↗</button>
            </div>
          </div>
        </div>
      </div>
    </section><style>{`
    
.feature-ac-6s{ margin-top:18px}
.feature-ac-6{display:flex; gap:12px; align-items:flex-start; flex:1; margin-top:18px;
  background: rgba(144, 202, 249,0.51);padding:10px 15px;border-radius:10px;}
.ficon-ac-6{display:flex; align-items:center; justify-content:center; border-radius:10px; background:rgba(144, 202, 249,1);padding:8px 12px; }
.feature-ac-6 .small-ac-6{font-size:13px; margin:6px 0 0; opacity:0.9}

.cr-record-grid-ac-6 {margin-top:50px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.rec-item-ac-6 {
  text-align: center;
}

.ricon-ac-6 {
  font-size: 46px;
  color: rgba(144, 202, 249,1);
}

.num-ac-6 {
  font-size: 34px;
  font-weight: 700;
  margin-top: 6px;
}


.big-ac-6 {
  font-size: 70px;
  font-weight: 800;
}


.label-ac-6 {
  font-size: 12px;
  margin-top: 6px;
  letter-spacing: 0.5px;
  color: #444;
}
.label-ac-6-two {
  font-size: 22px;
  margin-top: 6px;
  letter-spacing: 0.5px;
  color: #444;
}
/* File: MallAboutSection.css */
.mall-about{background:#fff;font-family:Inter,sans-serif;padding:60px 40px;}
.mall-grid{display:flex;gap:40px;align-items:flex-start}
.mall-left{flex:1;margin-top:50px;padding:15px;}
.mall-main-img{width:100%;border-radius:18px;box-shadow:0 4px 20px rgba(0,0,0,0.06)}
.mall-right{flex:1;background:rgba(144, 202, 249,0.1);padding:15px}
.mall-right h2{font-size:34px;font-weight:700;color:rgba(144, 202, 249,1)}
.line{width:60px;height:4px;background:rgba(144, 202, 249,1);margin:12px 0 18px}
.mall-right p{font-size:16px;color:#555;line-height:1.7;max-width:520px}
.mall-mini-grid{display:flex;gap:20px;margin-top:30px}
.mini-card{position:relative;flex:1}
.mini-card img{width:100%;height:330px;object-fit:cover;border-radius:18px}
.mini-btn{position:absolute;bottom:18px;left:18px;background:rgba(0,0,0,0.7);color:#fff;padding:10px 18px;border-radius:10px;border:none;cursor:pointer;font-weight:600}
@media(max-width:960px){.mall-about{padding:5px 5px;}.mall-left{padding:10px;}.mall-grid{flex-direction:column}.mall-mini-grid{flex-direction:column}}`}</style>
 </> );
}
